<template>
  <div>
      <!-- :style="{display:(popoverVisible?'':'none')}" -->
      <!-- <el-row><h3>请选择站点</h3></el-row> -->
      <el-row>
          <el-col :span="24"  v-for ="(site, index) in subSites" :key="index"> 
            <el-radio v-model="selectedSite" :label="site" @change="redirectDisable = false">{{site}}</el-radio>
          </el-col>          
      </el-row>
      <el-row style="margin-top:10px">    
          <el-col :span="6" :offset="6"><el-button type="primary" size="mini" :disabled="redirectDisable" @click="redirect" >确定</el-button></el-col>
          <el-col :span="6"><el-button type="primary" size="mini"  @click="close">取消</el-button></el-col> 
      </el-row>
  </div>
</template>

<script>
    // import store from '../store';
    export default {
        name: "SubSites",
        data () {
            return {
                selectedSite: "",
                redirectDisable: true,
            };
        },
        props: ['appId', "subSites"],
        methods: {
            redirect(){
                var url = this.$apis.sso + "/authz?appId=" + this.appId;
                if(this.selectedSite){
                    url += "&appSite=" + this.selectedSite;
                }
                // window.location.href = url;
                window.open(url, '_blank');
            },
            close(){
                this.$bus.$emit('closePopover', this.appId);
            }     
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SubSites.vue